export default __webpack_public_path__ + "static/new-tv-40e1fccd80be0329e9123b17e39258e2.jpg";